module.exports = __webpack_public_path__ + "static/media/1.5.9ace0d00.png";